import React, { useState } from "react";
import { Zap, Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { useLang } from "@/context/LangContext";

// طريقة النشر على مستوى الحساب — تُغيَّر من هنا فقط (صفحة قنوات التواصل)
export const PublishMode = ({ addon, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const { t: tr } = useLang();
  const mode = addon?.publish_mode || null;
  const set = async (m) => {
    if (m === mode) return;
    setBusy(true);
    try {
      await api.put("/social/publish-mode", { mode: m });
      toast.success(m === "super_rawaj" ? tr("سوبر رواج يتكفّل بالنشر وسحب الأداء — اربط حسابك ثم أنشئ حملتك", "Super Rawaj handles publishing and metrics — connect your account, then create your campaign") : tr("المسار اليدوي: سترفع المحتوى وتدخل أرقام الأداء بنفسك", "Manual mode: you upload content and enter performance numbers yourself"));
      onChanged?.();
    } catch (e) { toast.error(formatError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const OPTS = [
    ["super_rawaj", Zap, tr("سوبر رواج (تلقائي)", "Super Rawaj (automatic)"), tr("اربط حساباتك أولاً، ثم كل حملة تُنشر وتُسحب أرقامها تلقائياً — بلا رفع ولا إدخال يدوي.", "Connect your accounts first; every campaign is then published and its metrics pulled automatically — no uploads or manual entry.")],
    ["manual", Upload, tr("يدوي", "Manual"), tr("ترفع المحتوى بنفسك وتدخل أرقام الأداء لكل منشور.", "You upload the content yourself and enter performance numbers per post.")],
  ];
  return (
    <div className="glass rounded-2xl p-5 border border-border" data-testid="publish-mode-section">
      <div className="flex items-center justify-between gap-3 flex-wrap mb-3">
        <h2 className="font-bold flex items-center gap-2"><Zap className="w-5 h-5 text-primary" /> {tr("طريقة نشر حملاتك", "How your campaigns are published")}</h2>
        {busy && <Loader2 className="w-4 h-4 animate-spin text-primary" />}
      </div>
      <div className="grid sm:grid-cols-2 gap-2">
        {OPTS.map(([k, Icon, t, d]) => (
          <button key={k} onClick={() => set(k)} disabled={busy} data-testid={`publish-mode-${k}`}
            className={`text-start rounded-xl border p-3 transition-colors ${mode === k ? "border-primary bg-primary/10" : "border-border hover:border-primary/40"}`}>
            <div className="flex items-center gap-2 font-bold text-sm"><Icon className="w-4 h-4 text-primary" /> {t}{mode === k && <span className="text-[10px] px-2 py-0.5 rounded-full bg-primary text-white">{tr("المعتمد", "Selected")}</span>}</div>
            <div className="text-[11px] text-muted-foreground mt-1 leading-relaxed">{d}</div>
          </button>
        ))}
      </div>
      <p className="text-[11px] text-muted-foreground mt-2">{tr("تغيير الطريقة يتم من هذه الصفحة فقط ويسري على الحملات غير المجدولة.", "The mode is changed only from this page and applies to campaigns not yet scheduled.")}</p>
    </div>
  );
};
